import styled from '@emotion/styled';
import { Breakpoints, Colors, IconName } from 'goalsetter-webapp-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;
  width: 864px;
  margin-bottom: 70px;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    width: 95%;
    padding-top: 16px;
    padding-bottom: 42px;
  }
`;

export const StyledTitle = styled.div`
  padding: 30px 0;
  width: 100%;
  color: ${Colors.WHITE};
  font-family: Avenir;
  font-size: 56px;
  font-style: normal;
  font-weight: 900;
  line-height: 72px;
  text-align: center;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    font-size: 32px;
    font-weight: 800;
    line-height: 48px;
  }
`;

export const StyledDescription = styled.div`
  color: ${Colors.BLUE_INVESTMENTS};
  font-family: Avenir;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 32px;
`;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 16px;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  padding: 24px 0;
  flex-wrap: wrap;
  gap: 8px;
`;

export const registeredTrademarkStyle = {
  fontSize: '24px',
  verticalAlign: 'baseline',
};

export const descriptionRegisteredTrademarkStyle = {
  fontSize: '12px',
  verticalAlign: 'baseline',
};

export const cardStyle = {
  width: '100%',
};

export const buttonStyle = (isSelected?: boolean) => ({
  backgroundColor: isSelected ? Colors.ORANGE : Colors.WHITE,
  border: `2px solid ${isSelected ? 'none' : Colors.ORANGE}`,
  height: '56px',
  borderRadius: '8px',
});

export const buttonLeftIconStyle = {
  paddingRight: '8px',
  width: '20px',
};
